<template>
  <div>
    <el-dialog title="新增合服任务" center :visible="true" @close="onClose" :close-on-click-modal="false"
      :close-on-press-escape="false" width="500px">
      <el-form ref="form" :model="form" label-position="left" label-width="160px" size="mini">
        <el-form-item label="分区范围的指定方式：">
          <el-radio-group v-model="form.zoneRangeType">
            <el-radio label="range">按照区间</el-radio>
            <el-radio label="set">按照集合</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="待合服的分区区间：" v-if="form.zoneRangeType === 'range'">
          <el-input v-model="form.minZoneId" style="width: 100px" placeholder="比如“1”"></el-input>
          ~
          <el-input v-model="form.maxZoneId" style="width: 100px" placeholder="比如“10”"></el-input>
        </el-form-item>

        <el-form-item label="待合服的分区集合：" v-if="form.zoneRangeType === 'set'">
          <el-input v-model="form.zoneIdSetStr" type="textarea" style="width: 300px"
            placeholder="以空格分隔，比如“1 2 3 5 9 10”"></el-input>
        </el-form-item>

        <el-form-item label="合服后的主分区：">
          <el-input v-model="form.masterZoneId" style="width: 100px" placeholder="比如“1”"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="onClose" style="margin-left: 0px">取消</el-button>
          <el-button type="primary" icon="el-icon-warning-outline" @click="mergeZone()"
            style="margin-left: 20px">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
import { max } from "moment";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "MergeZonesDialog";

export default {
  data() {
    return {
      form: {
        masterZoneId: "",
        zoneRangeType: "range",
        zoneIdSetStr: "",
        minZoneId: "",
        maxZoneId: "",
      },
    };
  },

  async created() { },

  methods: {
    async mergeZone() {
      let masterZoneId = Number(this.form.masterZoneId.trim());
      if (isNaN(masterZoneId) || masterZoneId <= 0) {
        this.$alert("请检查输入", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      let zoneSet = [];

      if (this.form.zoneRangeType === "range") {
        let minZoneId = Number(this.form.minZoneId.trim());
        if (isNaN(minZoneId) || minZoneId <= 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        let maxZoneId = Number(this.form.maxZoneId.trim());
        if (isNaN(maxZoneId) || maxZoneId <= 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        if (minZoneId >= maxZoneId) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        for (let zoneId = minZoneId; zoneId <= maxZoneId; zoneId++) {
          zoneSet.push(zoneId);
        }
      } else if (this.form.zoneRangeType === "set") {
        let zoneIdStrs = this.form.zoneIdSetStr.trim().split(/\s+/);
        if (zoneIdStrs.length < 2) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        for (let zoneIdStr of zoneIdStrs) {
          let zoneId = Number(zoneIdStr.trim());
          if (isNaN(zoneId) || zoneId <= 0) {
            this.$alert("请检查输入", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }

          if (zoneSet.indexOf(zoneId) != -1) {
            this.$alert("请检查输入，分区集合中不能有重复的分区", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }

          zoneSet.push(zoneId);
        }
      }

      // 确保合服后的主分区是在待合服范围内的
      if (zoneSet.indexOf(masterZoneId) == -1) {
        this.$alert("请检查输入，合服后的主分区必须在待合服分区范围内", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      try {
        // 弹确认框
        await this.$confirm(
          `确认开始合服？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/mergeZones`,
            {
              masterZone: masterZoneId,
              zoneSet: zoneSet,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "成功",
          type: "success",
        });

        this.onClose();
      } catch (e) { }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>